export const languages = [
   "English", "Mandarin Chinese", "Hindi", "Spanish", "French", "Arabic", "Bengali", "Portuguese",
   "Russian", "Urdu", "Indonesian", "German", "Japanese", "Swahili", "Marathi", "Telugu", "Turkish",
   "Tamil", "Cantonese", "Vietnamese", "Korean", "Italian", "Polish", "Ukrainian", "Romanian", "Dutch",
   "Thai", "Gujarati", "Persian", "Bhojpuri", "Tagalog", "Yoruba", "Hausa", "Burmese", "Kannada",
   "Sindhi", "Odia", "Kurdish", "Malay", "Igbo", "Amharic", "Chhattisgarhi", "Malagasy", "Uzbek",
   "Sinhalese", "Zulu", "Hebrew", "Lao", "Khmer", "Basque", "Armenian", "Azerbaijani", "Belarusian",
   "Bosnian", "Bulgarian", "Catalan", "Chechen", "Czech", "Danish", "Estonian", "Finnish", "Georgian",
   "Greek", "Haitian Creole", "Hungarian", "Icelandic", "Irish Gaelic", "Kazakh", "Latvian", "Lithuanian",
   "Luxembourgish", "Macedonian", "Maltese", "Mongolian", "Nepali", "Norwegian", "Pashto", "Punjabi",
   "Serbian", "Slovak", "Slovenian", "Somali", "Tatar", "Turkmen", "Uighur", "Uzbek", "Welsh", "Wolof",
   "Xhosa", "Maori", "Tibetan", "Greenlandic", "Cebuano", "Shanghainese", "Fijian", "Sotho", "Dhivehi",
   "Tswana", "Mandinka", "Konkani", "Meitei (Manipuri)", "Rajasthani", "Awadhi", "Magahi", "Saraiki",
   "Dogri", "Sylheti", "Bravanese", "Garhwali", "Assamese", "Ladakhi", "Mizo", "Tripuri", "Chakma",
   "Bodo", "Santali", "Ho", "Kurukh", "Waray", "Ilocano", "Pangasinan", "Hiligaynon", "Bicolano",
   "Tausug", "Chamorro", "Marshallese", "Gilbertese", "Aymara", "Quechua", "Guarani", "Mapudungun",
   "Nahuatl", "Otomi", "Totonac", "Mixtec", "Zapotec", "Tsonga", "Venda", "Maltese", "Shona", "Sardinian",
   "Tamasheq", "Hmong", "Corsican", "Papiamento", "Bashkir", "Chuvash", "Mari", "Udmurt", "Tuvan",
   "Evenki", "Nenets", "Aleut", "Sami", "Yiddish", "Romani", "Crimean Tatar", "Ossetian", "Adyghe",
   "Kabardian", "Karachay-Balkar", "Ingush", "Lak", "Lezgian", "Abkhaz", "Bashkir", "Yakut", "Tuvan",
   "Mansi", "Khanty", "Even", "Nanai", "Nivkh", "Koryak", "Itelmen", "Ainu", "Komi", "Erzya", "Moksha",
   "Mari", "Buryat", "Kalmyk", "Tuvan", "Altai", "Udege", "Daur", "Negidal", "Evensk", "Chukchi",
   "Koryak", "Nganasan", "Selkup", "Yukaghir", "Tuvan", "Khakas", "Sakha", "Dolgan", "Nenets", "Enets",
   "Veps", "Karelian", "Ingrian", "Meänkieli", "Lule Sami", "Pite Sami", "Ume Sami", "Skolt Sami",
   "Inari Sami", "Kildin Sami"
 ];


 export const languageQuestions = {
   "English": "Ask a question...",
   "Mandarin Chinese": "提出问题...",
   "Hindi": "प्रश्न पूछें...",
   "Spanish": "Haz una pregunta...",
   "French": "Posez une question...",
   "Arabic": "اطرح سؤالا...",
   "Bengali": "একটি প্রশ্ন জিজ্ঞাসা করুন...",
   "Portuguese": "Faça uma pergunta...",
   "Russian": "Задайте вопрос...",
   "Urdu": "سوال پوچھیں...",
   "Indonesian": "Ajukan pertanyaan...",
   "German": "Stellen Sie eine Frage...",
   "Japanese": "質問してください...",
   "Swahili": "Uliza swali...",
   "Marathi": "प्रश्न विचारा...",
   "Telugu": "ప్రశ్న అడగండి...",
   "Turkish": "Bir soru sorun...",
   "Tamil": "கேள்வி கேளுங்கள்...",
   "Cantonese": "提出問題...",
   "Vietnamese": "Đặt câu hỏi...",
   "Korean": "질문하기...",
   "Italian": "Fai una domanda...",
   "Polish": "Zadaj pytanie...",
   "Ukrainian": "Задайте питання...",
   "Romanian": "Pune o întrebare...",
   "Dutch": "Stel een vraag...",
   "Thai": "ถามคำถาม...",
   "Gujarati": "પ્રશ્ન પૂછો...",
   "Persian": "سوال بپرسید...",
   "Bhojpuri": "सवाल पूछीं...",
   "Tagalog": "Magtanong...",
   "Yoruba": "Béèrè ìbéèrè...",
   "Hausa": "Yi tambaya...",
   "Burmese": "မေးခွန်းမေးပါ...",
   "Kannada": "ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿ...",
   "Sindhi": "سوال پڇو...",
   "Odia": "ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ...",
   "Kurdish": "Pirsekê bipirsin...",
   "Malay": "Ajukan soalan...",
   "Igbo": "Jụọ ajụjụ...",
   "Amharic": "ጥያቄ ይጠይቁ...",
   "Chhattisgarhi": "सवाल पूछो...",
   "Malagasy": "Mametraha fanontaniana...",
   "Uzbek": "Savol bering...",
   "Sinhalese": "ප්‍රශ්නයක් අසන්න...",
   "Zulu": "Buza umbuzo...",
   "Hebrew": "שאל שאלה...",
   "Lao": "ຖາມຄໍາຖາມ...",
   "Khmer": "សួរសំណួរ...",
   "Basque": "Egin galdera bat...",
   "Armenian": "Հարց տվեք...",
   "Azerbaijani": "Sual verin...",
   "Belarusian": "Задайце пытанне...",
   "Bosnian": "Postavite pitanje...",
   "Bulgarian": "Задайте въпрос...",
   "Catalan": "Fes una pregunta...",
   "Chechen": "Хаттар де...",
   "Czech": "Položte otázku...",
   "Danish": "Stil et spørgsmål...",
   "Estonian": "Küsi küsimus...",
   "Finnish": "Kysy kysymys...",
   "Georgian": "დასვით შეკითხვა...",
   "Greek": "Κάντε μια ερώτηση...",
   "Haitian Creole": "Poze yon kesyon...",
   "Hungarian": "Tegyen fel egy kérdést...",
   "Icelandic": "Spyrðu spurningu...",
   "Irish Gaelic": "Cuir ceist...",
   "Kazakh": "Сұрақ қойыңыз...",
   "Latvian": "Uzdodiet jautājumu...",
   "Lithuanian": "Užduokite klausimą...",
   "Luxembourgish": "Stellt eng Fro...",
   "Macedonian": "Поставете прашање...",
   "Maltese": "Staqsi mistoqsija...",
   "Mongolian": "Асуулт асуу...",
   "Nepali": "प्रश्न सोध्नुहोस्...",
   "Norwegian": "Still et spørsmål...",
   "Pashto": "پوښتنه وکړئ...",
   "Punjabi": "ਸਵਾਲ ਪੁੱਛੋ...",
   "Serbian": "Поставите питање...",
   "Slovak": "Položte otázku...",
   "Slovenian": "Postavite vprašanje...",
   "Somali": "Weydii su'aal...",
   "Tatar": "Сорау бирегез...",
   "Turkmen": "Sorag beriň...",
   "Uighur": "سوئال سوراڭ...",
   "Welsh": "Gofynnwch gwestiwn...",
   "Wolof": "Laaj laaj...",
   "Xhosa": "Buza umbuzo...",
   "Maori": "Pātai tētahi pātai...",
   "Tibetan": "དྲི་བ་ཞིག་དྲིས།...",
   "Greenlandic": "Apeqqut aperigit...",
   "Cebuano": "Pangutana...",
   "Shanghainese": "提個問題...",
   "Fijian": "Taroga e dua na taro...",
   "Sotho": "Botsa potso...",
   "Dhivehi": "ސުވާލެއް ކުރައްވާ...",
   "Tswana": "Botsa potso...",
   "Mandinka": "Ñininkali ke...",
   "Konkani": "प्रश्न विचार...",
   "Meitei (Manipuri)": "ꯍꯪꯕꯤꯌꯨ...",
   "Rajasthani": "सवाल पूछो...",
   "Awadhi": "सवाल पूछो...",
   "Magahi": "सवाल पूछू...",
   "Saraiki": "سوال پچھو...",
   "Dogri": "सवाल पुच्छो...",
   "Sylheti": "সোয়াল ফুছին...",
   "Bravanese": "Su'aal weydii...",
   "Garhwali": "सवाल पूछो...",
   "Assamese": "প্ৰশ্ন সোধক...",
   "Ladakhi": "འདྲི་བ་ཞིག་དྲིས།...",
   "Mizo": "Zawhna zawt rawh...",
   "Tripuri": "কোকয় সাবি...",
   "Chakma": "𑄥𑄧𑄣𑄴 𑄎𑄨𑄉𑄟...",
   "Bodo": "सोंथि सोङो...",
   "Santali": "ᱠᱩᱞᱤ ᱢᱮᱱᱟᱜᱼᱟ...",
   "Ho": "कुईली मे...",
   "Kurukh": "केले आस...",
   "Waray": "Pagkiana...",
   "Ilocano": "Agsaludsod...",
   "Pangasinan": "Manpabaki...",
   "Hiligaynon": "Pamangkot...",
   "Bicolano": "Maghapot...",
   "Tausug": "Mag-pangutana...",
   "Chamorro": "Famaisen...",
   "Marshallese": "Kajjitōk...",
   "Gilbertese": "Titirakina te titiraki...",
   "Aymara": "Jiskt'aña...",
   "Quechua": "Tapuyta tapuy...",
   "Guarani": "Eporandu...",
   "Mapudungun": "Ramtun...",
   "Nahuatl": "Xitlajtlani...",
   "Otomi": "ʼYändi̲ ʼnar ntʼa̲ni...",
   "Totonac": "Katputzan...",
   "Mixtec": "Kaka̲tu'ún...",
   "Zapotec": "Gunaba diidxa...",
   "Tsonga": "Vutisa xivutiso...",
   "Venda": "Vhudzisa mbudziso...",
   "Shona": "Bvunza mubvunzo...",
   "Sardinian": "Faghe una pregunta...",
   "Tamasheq": "Sesteq tansesteqt...",
   "Hmong": "Nug ib lo lus nug...",
   "Corsican": "Fà una dumanda...",
   "Papiamento": "Hasi un pregunta...",
   "Bashkir": "Һорау бирегеҙ...",
   "Chuvash": "Ыйту парӑр...",
   "Mari": "Йодышым йодса...",
   "Udmurt": "Юан сётэ...",
   "Tuvan": "Айтырыг салыңар...",
   "Evenki": "Гунми...",
   "Nenets": "Юнрава...",
   "Aleut": "Aam̂is...",
   "Sami": "Jeara gažaldaga...",
   "Yiddish": "פרעג א פראגע...",
   "Romani": "Puchav puchimos...",
   "Crimean Tatar": "Sual soraňız...",
   "Ossetian": "Фарст радт...",
   "Adyghe": "УпчӀэ къэгъэув...",
   "Kabardian": "УпщӀэ етын...",
   "Karachay-Balkar": "Сорув берирге...",
   "Ingush": "Хаттар де...",
   "Lak": "Суал була...",
   "Lezgian": "Суал це...",
   "Abkhaz": "Азҵаара...",
   "Yakut": "Ыйыт...",
   "Mansi": "Китыглахтуӈкве...",
   "Khanty": "Иньщасты...",
   "Even": "Гун...",
   "Nanai": "Мэдэсигуэри...",
   "Nivkh": "Пʼытʼ...",
   "Koryak": "Йепиӈийык...",
   "Itelmen": "Схʔенӈин...",
   "Ainu": "ウエンタラウケ...",
   "Komi": "Юалӧм сет...",
   "Erzya": "Кевкстема максомс...",
   "Moksha": "Кизефтемс...",
   "Buryat": "Асуулга табиха...",
   "Kalmyk": "Сурвр өгтн...",
   "Altai": "Сурак берер...",
   "Udege": "Хаинди...",
   "Daur": "Асу...",
   "Negidal": "Мэдэси...",
   "Evensk": "Гукэр...",
   "Chukchi": "Валёманак...",
   "Nganasan": "Хюрси...",
   "Selkup": "Кыты...",
   "Yukaghir": "Пандьаак...",
   "Khakas": "Сурығ пирерге...",
   "Sakha": "Ыйыт...",
   "Dolgan": "Ыйыт...",
   "Enets": "Пуда...",
   "Veps": "Küzuda küzumine...",
   "Karelian": "Kyzyö kyzymys...",
   "Ingrian": "Küsyä küsümüs...",
   "Meänkieli": "Kysy kysymys...",
   "Lule Sami": "Gatjáda...",
   "Pite Sami": "Gatjádallat...",
   "Ume Sami": "Gatjádallat...",
   "Skolt Sami": "Kõõjjâd kõõččmõõžž...",
   "Inari Sami": "Koijâd koččâmuš...",
   "Kildin Sami": "Кыӈӈлэдтэ..."
 };
  export const languageCodes = {
   "English": "en",
   "Mandarin Chinese": "zh",
   "Hindi": "hi",
   "Spanish": "es",
   "French": "fr",
   "Arabic": "ar",
   "Bengali": "bn",
   "Portuguese": "pt",
   "Russian": "ru",
   "Urdu": "ur",
   "Indonesian": "id",
   "German": "de",
   "Japanese": "ja",
   "Swahili": "sw",
   "Marathi": "mr",
   "Telugu": "te",
   "Turkish": "tr",
   "Tamil": "ta",
   "Cantonese": "yue",
   "Vietnamese": "vi",
   "Korean": "ko",
   "Italian": "it",
   "Polish": "pl",
   "Ukrainian": "uk",
   "Romanian": "ro",
   "Dutch": "nl",
   "Thai": "th",
   "Gujarati": "gu",
   "Persian": "fa",
   "Bhojpuri": "bho",
   "Tagalog": "tl",
   "Yoruba": "yo",
   "Hausa": "ha",
   "Burmese": "my",
   "Kannada": "kn",
   "Sindhi": "sd",
   "Odia": "or",
   "Kurdish": "ku",
   "Malay": "ms",
   "Igbo": "ig",
   "Amharic": "am",
   "Chhattisgarhi": "hne",
   "Malagasy": "mg",
   "Uzbek": "uz",
   "Sinhalese": "si",
   "Zulu": "zu",
   "Hebrew": "he",
   "Lao": "lo",
   "Khmer": "km",
   "Basque": "eu",
   "Armenian": "hy",
   "Azerbaijani": "az",
   "Belarusian": "be",
   "Bosnian": "bs",
   "Bulgarian": "bg",
   "Catalan": "ca",
   "Chechen": "ce",
   "Czech": "cs",
   "Danish": "da",
   "Estonian": "et",
   "Finnish": "fi",
   "Georgian": "ka",
   "Greek": "el",
   "Haitian Creole": "ht",
   "Hungarian": "hu",
   "Icelandic": "is",
   "Irish Gaelic": "ga",
   "Kazakh": "kk",
   "Latvian": "lv",
   "Lithuanian": "lt",
   "Luxembourgish": "lb",
   "Macedonian": "mk",
   "Maltese": "mt",
   "Mongolian": "mn",
   "Nepali": "ne",
   "Norwegian": "no",
   "Pashto": "ps",
   "Punjabi": "pa",
   "Serbian": "sr",
   "Slovak": "sk",
   "Slovenian": "sl",
   "Somali": "so",
   "Tatar": "tt",
   "Turkmen": "tk",
   "Uighur": "ug",
   "Welsh": "cy",
   "Wolof": "wo",
   "Xhosa": "xh",
   "Maori": "mi",
   "Tibetan": "bo",
   "Greenlandic": "kl",
   "Cebuano": "ceb",
   "Shanghainese": "wuu",
   "Fijian": "fj",
   "Sotho": "st",
   "Dhivehi": "dv",
   "Tswana": "tn",
   "Mandinka": "mnk",
   "Konkani": "kok",
   "Meitei (Manipuri)": "mni",
   "Rajasthani": "raj",
   "Awadhi": "awa",
   "Magahi": "mag",
   "Saraiki": "skr",
   "Dogri": "doi",
   "Sylheti": "syl",
   "Bravanese": "brv",
   "Garhwali": "gbm",
   "Assamese": "as",
   "Ladakhi": "lbj",
   "Mizo": "lus",
   "Tripuri": "trp",
   "Chakma": "ccp",
   "Bodo": "brx",
   "Santali": "sat",
   "Ho": "hoc",
   "Kurukh": "kru",
   "Waray": "war",
   "Ilocano": "ilo",
   "Pangasinan": "pag",
   "Hiligaynon": "hil",
   "Bicolano": "bik",
   "Tausug": "tsg",
   "Chamorro": "ch",
   "Marshallese": "mh",
   "Gilbertese": "gil",
   "Aymara": "ay",
   "Quechua": "qu",
   "Guarani": "gn",
   "Mapudungun": "arn",
   "Nahuatl": "nah",
   "Otomi": "oto",
   "Totonac": "top",
   "Mixtec": "mix",
   "Zapotec": "zap",
   "Tsonga": "ts",
   "Venda": "ve",
   "Shona": "sn",
   "Sardinian": "sc",
   "Tamasheq": "tmh",
   "Hmong": "hmn",
   "Corsican": "co",
   "Papiamento": "pap",
   "Bashkir": "ba",
   "Chuvash": "cv",
   "Mari": "chm",
   "Udmurt": "udm",
   "Tuvan": "tyv",
   "Evenki": "evn",
   "Nenets": "yrk",
   "Aleut": "ale",
   "Sami": "se",
   "Yiddish": "yi",
   "Romani": "rom",
   "Crimean Tatar": "crh",
   "Ossetian": "os",
   "Adyghe": "ady",
   "Kabardian": "kbd",
   "Karachay-Balkar": "krc",
   "Ingush": "inh",
   "Lak": "lbe",
   "Lezgian": "lez",
   "Abkhaz": "ab",
   "Yakut": "sah",
   "Mansi": "mns",
   "Khanty": "kca",
   "Even": "eve",
   "Nanai": "gld",
   "Nivkh": "niv",
   "Koryak": "kpy",
   "Itelmen": "itl",
   "Ainu": "ain",
   "Komi": "kv",
   "Erzya": "myv",
   "Moksha": "mdf",
   "Buryat": "bua",
   "Kalmyk": "xal",
   "Altai": "alt",
   "Udege": "ude",
   "Daur": "dta",
   "Negidal": "neg",
   "Evensk": "eve",
   "Chukchi": "ckt",
   "Nganasan": "nio",
   "Selkup": "sel",
   "Yukaghir": "yux",
   "Khakas": "kjh",
   "Sakha": "sah",
   "Dolgan": "dlg",
   "Enets": "enf",
   "Veps": "vep",
   "Karelian": "krl",
   "Ingrian": "izh",
   "Meänkieli": "fit",
   "Lule Sami": "smj",
   "Pite Sami": "sje",
   "Ume Sami": "sju",
   "Skolt Sami": "sms",
   "Inari Sami": "smn",
   "Kildin Sami": "sjd"
 };


